// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"k1-z","colorTextValue":"l1-z","swatches":"m1-z","collapseLink":"n1-z","isCollapsed":"o1-z","dropdown":"p1-z","disabled":"q1-z"};